export default __webpack_public_path__ + "src/images/packages/cradle-boutique-hotel/c446de0bef72e59e15d33130154b4d72-5.png";